<div class="modal-overlay" (click)="onOverlayClick($event)">
  <div class="modal-container" [class.modal-sm]="size === 'sm'" [class.modal-lg]="size === 'lg'" [class.modal-xl]="size === 'xl'">
    <!-- Header -->
    <div class="modal-header" [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }">
      <h2 class="modal-title"></h2>
      <button type="button" class="close-btn" aria-label="Close" (click)="declineAction()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <!-- Content -->
    <div class="modal-body">
      <!-- Base Content -->
      <div class="modal-content">
        <img
          *ngIf="icon"
          class="modal-img"
          [style]="icon ? 'transform: scaleX(1)' : ''"
          width="40"
          height="40"
          [src]="icon ? icon : 'assets/icons/search-result/airplane_3313713.svg'"
          alt="airplane"
        />

        <div class="text-center" [ngClass]="titleReverse ? 'd-flex flex-column-reverse' : ''">
          <h2 class="modal-title" *ngIf="title">{{ title }}</h2>
          <h3 class="modal-subtitle" *ngIf="subtitle">{{ subtitle }}</h3>
        </div>

        <p class="modal-text" [innerHTML]="message"></p>
      </div>

      <!-- Custom Content -->
      <ng-content></ng-content>
    </div>

    <!-- Footer -->
    <div class="modal-footer" *ngIf="showCancelButton">
      <button type="button" class="btn btn-cancel" (click)="declineAction()">
        {{ cancelText }}
      </button>
      <button type="button" *ngIf="showExtraButton" class="btn btn-confirm" [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }" (click)="extraAction()">
        {{ extraText }}
      </button>
      <button type="button" class="btn btn-confirm" [class.btn-confirm--stacked]="confirmSubText" [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }" (click)="confirmAction()">
        <span class="btn-confirm-main">{{ confirmText }}</span>
        <span class="btn-confirm-sub" *ngIf="confirmSubText">{{ confirmSubText }}</span>
      </button>
    </div>
  </div>
</div>
